<template>
  <div id="sp">
    <div class="diamondSponsors mt-1 mb-2" v-for="{ name, id }, index in categories" :key="id">
      <div class="sponsorHeading">
        <h3 class="sponsor-font">{{ name }}</h3>
      </div>
      <Sponsors :categoryId="id" :index="index" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Sponsors from './Sponsors.vue';

export default {
  components: {
    Sponsors,
  },
  data() {
    return {
      categories: [],
    };
  },
  async mounted() {
    if (this.$route.params.eventId) {
      this.categories = await this.fetchEventCategories(this.$route.params.eventId);
    }
    if (this.$route.params.awardId) {
      this.categories = await this.fetchAwardCategories(this.$route.params.awardId);
    }
  },
  methods: {
    ...mapActions({
      fetchEventCategories: 'events/fetchEventCategories',
      fetchAwardCategories: 'awards/fetchAwardCategories',
      fetchEventSponsors: 'awards/fetchEventSponsors',
      fetchAwardSponsors: 'awards/fetchAwardSponsors',
    }),
  },
};
</script>

<style scoped>
.sponsorHeading {
  text-align: center;
  border-radius: 0 10px 0 0;
  color: #bd9d5f;
  background-color: #f3f3f3;
  height: 45px;
}
.sponsor-font {
  font-size: 18px;
  text-transform: uppercase;
  line-height: 47px;
}
.sponsorImg {
  width: 100%;
  padding: 46px 26px 0px 26px;
}
.sponsorImg-100 {
  padding: 7px 26px 11px 26px;
  width: 100%;
}
.sponsorImg-75 {
  padding: 17px 82px 0px 95px;
  width: 100%;
}
.sponsorImg-50 {
  padding: 2px 57px 0px 72px;
  width: 100%;
}
.partOne,
.partTwo {
  height: 150px;
  border-top: 1px solid rgb(231, 231, 231);
  background-color: #ffffff;
}
.partOne-100,
.partTwo-100 {
  height: 100px;
  border-top: 1px solid rgb(231, 231, 231);
  background-color: #ffffff;
}

.partOne-75,
.partTwo-75 {
  height: 75px;
  border-top: 1px solid rgb(231, 231, 231);
  background-color: #ffffff;
}
.partOne-50,
.partTwo-50 {
  height: 50px;
  border-top: 1px solid rgb(231, 231, 231);
  background-color: #ffffff;
}

#associate-col {
  height: 50px;
  height: 50px;
  background: white;
  border-right: 1px solid #e5e5e5;
}
.associateImg {
  width: 100%;
  margin-top: -34px;
}
.platiniumSponsors {
  width: 280px;
  background: rgb(12, 41, 41) !important;
  position: relative !important;
  bottom: 25px;
}
.goldSponsors {
  width: 280px;
  background: rgb(13, 226, 13) !important;
  position: relative !important;
  bottom: 11px;
}
.silverSponsors {
  width: 280px;
  background: rgb(36, 0, 121) !important;
  position: relative !important;
  bottom: 1px;
}
.associateSponsors {
  width: 280px;
  background: rgb(175, 23, 23) !important;
  position: relative !important;
  top: 10px;
}
.mediaPartners {
  width: 280px;
  background: rgb(44, 77, 2) !important;
  position: relative !important;
}
</style>
